import React, { FC, useState, useEffect } from 'react'
import TextInput from '../../UI/Inputs/TextInput';
import CustomButton from '../../UI/Buttons/CustomButton';
import Form from '../../Form';
import { FormikHelpers, useFormikContext } from 'formik';
import { TBillingAddressValues } from '../../../models/form';
import ErrorMessage from '../../../components/UI/Tooltips/ErrorMessage';
import './BillingInformation.scss'


interface BillingInformationProps {
    inProgress: boolean,
    error:any,
    saveCallBack: any,
    isEditable?: boolean,
    billingAddress: TBillingAddressValues
}

const BillingInformation: FC<BillingInformationProps> = ({ inProgress, saveCallBack, isEditable = false, billingAddress, error }) => {

    const [disableField, setDisableField] = useState(false);


    useEffect(() => {
        setDisableField(isEditable);
    }, [isEditable])

    useEffect(() => {
        if(inProgress == false && !error){
            setDisableField(true);
        }
    }, [inProgress, error])



    const setUpForm = {
        initialValues: {
            firstName: billingAddress.firstName || '',
            lastName: billingAddress.lastName || '',
            address: billingAddress.address &&  billingAddress.address !== 'null'? billingAddress.address:'',
            state: billingAddress.state && billingAddress.state !== 'null'?billingAddress.state:'',
            city: billingAddress.city && billingAddress.city !== 'null'?billingAddress.city:'',
            country: billingAddress.country || '',
            zip: billingAddress.zip || ''
        },
        validation: 'billing_address',
        enableReinitialize: true,
        onSubmit: async (values: TBillingAddressValues, actions: FormikHelpers<TBillingAddressValues>) => {
            saveCallBack(values);
        }
    }


    return (

        <div className="billing-container">
            <Form {...setUpForm}>
                <div className="divider">
                    <TextInput label="First Name" name="firstName" disabled={disableField} />
                    <TextInput label="Last Name" name="lastName" disabled={disableField} />
                </div>
                <div className="divider">
                    <TextInput label="Street Address" name="address" disabled={disableField} />
                </div>
                <div className="divider">
                    <TextInput label="State" name="state" disabled={disableField} />
                    <TextInput label="City" name="city" disabled={disableField} />
                </div>
                <div className="divider">
                    <TextInput label="Country" name="country" disabled={disableField} />
                    <TextInput label="Postalcode" name="zip" disabled={disableField} />
                </div>
                <div className="text-right">
                    {disableField ? <CustomButton
                        button='secondary'
                        type='button'
                        onClick={() => { setDisableField(false) }}
                    >
                        Edit
                    </CustomButton> : null}
                    {!disableField ? <CustomButton inProgress={inProgress} className='save-button' button='primary' type='submit'>
                        Save
                    </CustomButton> : null}
                </div>
            </Form>
            {error && <ErrorMessage text={error.error.message} />}
        </div>

    )
}

export default BillingInformation
